import { env } from 'common/env'
import { callBackend } from './fetch'

export interface StripeConnectStatus {
  configured: boolean
  connected: boolean
  chargesEnabled: boolean
  payoutsEnabled: boolean
  livemode: boolean
  accountDisplay?: string
  paymentBlocked: boolean
}

type ItemResponse<T> = { data?: T }

export class StripeConnectApi {
  async status(): Promise<StripeConnectStatus> {
    const response = await callBackend(`${env.endpoint}/api/stripe-connect/status`)
    const body = (await response.json()) as ItemResponse<StripeConnectStatus>
    return body.data ?? {
      configured: false,
      connected: false,
      chargesEnabled: false,
      payoutsEnabled: false,
      livemode: false,
      paymentBlocked: false,
    }
  }

  async authorizationUrl(): Promise<string> {
    const response = await callBackend(`${env.endpoint}/api/stripe-connect/authorize`, { method: 'POST' })
    const body = (await response.json()) as ItemResponse<string>
    if (!body.data) throw new Error('Stripe authorization URL is missing')
    return body.data
  }

  async disconnect(): Promise<void> {
    await callBackend(`${env.endpoint}/api/stripe-connect`, { method: 'DELETE' })
  }
}

export const stripeConnectApi = new StripeConnectApi()
